import styled from 'styled-components'

export const PageWrapper = styled.div`
  max-width: 1120px;
  margin-bottom: 8px;
  margin-top: 80px;
  margin-left: auto;
  margin-right: auto;
  padding: 24px;
`

export const DashboardCard = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
`

export const DashboardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
`

export const DashboardTitle = styled.h2`
  font-size: 22px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`
export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 560px;
`

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 14px;
  line-height: 16.5px;
  font-weight: 400;
  border: 1px solid;

  ${({ tone }) => {
    if (tone === 'success') {
      return `
        color: #15803D;
        background: #F0FDF4;
        border-color: #22C55E;
      `
    }
    if (tone === 'error') {
      return `
        color: #EF4444;
        background: #FFF7F7;
        border-color:#FF6969;
      `
    }
    return `
      color: #d97706;
      background: #fffbeb;
      border-color: #fde68a;
    `
  }}
`

export const SubmitButton = styled.button`
  background: #0ea5e9;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    background: #2586cc;
  }

  &:disabled {
    background: #cbd5e1;
    cursor: not-allowed;
  }
`

export const TabContent = styled.div`
  padding: 25px;
`
export const BoldText = styled.span`
  font-weight: 500;
`
